export interface PasswordRequirement {
  id: string;
  label: string;
  isValid: (password: string) => boolean;
}

export const PASSWORD_REQUIREMENTS: PasswordRequirement[] = [
  {
    id: "length",
    label: "Minimum 12 characters",
    isValid: (password) => password.length >= 12,
  },
  {
    id: "uppercase",
    label: "At least one uppercase letter",
    isValid: (password) => /[A-Z]/.test(password),
  },
  {
    id: "lowercase",
    label: "At least one lowercase letter",
    isValid: (password) => /[a-z]/.test(password),
  },
  {
    id: "number",
    label: "At least one number",
    isValid: (password) => /[0-9]/.test(password),
  },
  {
    id: "special",
    label: "At least one special character (!@#$%^&*...)",
    isValid: (password) => /[!@#$%^&*()_+\-=\[\]{}|;:,.<>?]/.test(password),
  },
];

export const validatePassword = (password: string): boolean => {
  return PASSWORD_REQUIREMENTS.every((req) => req.isValid(password));
};

export const getPasswordRequirementsStatus = (password: string) => {
  return PASSWORD_REQUIREMENTS.map((req) => ({
    ...req,
    met: req.isValid(password),
  }));
};
